import React from "react"
// import Contact from "../templates/contact-form-template.js"  // disabled, see below
// import { useTransitionState } from "gatsby-plugin-transition-link/hooks"
// import tw from "twin.macro"
import {
  Lead,
  Label,
  PageTitle,
  LeftSide,
  LeftContent,
  Job,
} from "../components/theme"

const Cv = () => {


  return (
    <div className="page-trans m-auto mb-k3v mt-k5v flex min-h-screen w-k8 flex-row flex-wrap items-baseline xl:ml-k2 xl:w-k7 2xl:ml-k3 2xl:w-k5">
      <div className="mb-8 w-full">
        <div className={LeftSide}></div>

        <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
          <h1 className={`${PageTitle} -mt-16 mb-2 font-normal sm:font-extralight`}>
            Curriculum Vitae
          </h1>
        </div>
      </div>
      <div className={LeftSide}>
        {/* <h2 className={Label}
        data-sal="fade" 
  data-sal-duration={900}>PROFILE</h2> */}
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <p className={` ${Lead} 2xl:pr-k25`}>
        I operate at the intersection of design and technology, translating creative intent into engineered systems. Drawing on mathematics, geometry and generative art, I build modular platforms and experiences designed to adapt and evolve.
        </p>
        <p className="2xl:pr-k25">
        I lead Design Technology for Europe, setting the technical direction and standards that creative, product and engineering teams build against. I work where the problem is still undefined: turning ambiguous briefs into architectures, and one-off solutions into systems other teams adopt. Three decades in, I have moved from print to the web to real-time 3D and AI, and I still build.
        </p>
        <p className="2xl:pr-k25">
        My craft blends engineering and visual language: functional and expressive, precise and playful, experimental and rigorous.
        </p>
        <p className="2xl:pr-k25">
        I’m motivated by transformation: ideas into systems, systems into experiences.
        </p>
      </div>
      <div className={LeftSide}>
        <h2 className={Label} data-sal="fade" data-sal-duration={900}>
          Location
        </h2>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <p>I am currently based in London, UK.</p>
      </div>
      <div className={LeftSide}>
        <h2
          data-sal="fade"
          data-sal-duration={900}
          className={Label}
        >
          Strategic{' '} 
          <br className="hidden md:block" />Skills
        </h2>
      </div>
      <div
        className={`${LeftContent} `}
        data-sal="fade"
        data-sal-duration={900}
      >
        <div className="">
          <ul className="mb-6 list-disc pl-4 md:pl-0 md:list-none fluid-text-base">
            <li>Technical direction and standards for multi-team adoption</li>
            <li>Design systems architecture and governance</li>
            <li>Discovery and innovation pipelines, scoping and estimation</li>
            <li>Team leadership, mentoring and capability building</li>
          </ul>
        </div>
      </div>
      <div className={LeftSide}>
        <h2 className={Label} data-sal="fade" data-sal-duration={900}>
          Design{' '} 
          <br className="hidden md:block" />Skills
        </h2>
      </div>
      <div
        className={`${LeftContent} `}
        data-sal="fade"
        data-sal-duration={900}
      >
        <div className="">
          <ul className="mb-6 list-disc pl-4 md:pl-0 md:list-none fluid-text-base">
            <li>Product design and prototyping across web, mobile and connected devices</li>
            <li>Design systems, tokens and multi-brand theming</li>
            <li>Motion, real-time 3D and generative systems</li>
            <li>Accessible and inclusive design (WCAG 2.2)</li>
          </ul>
        </div>
      </div>
      <div className={LeftSide}>
        <h2 className={Label} data-sal="fade" data-sal-duration={900}>
          Engineering{' '} 
          <br className="hidden md:block" />Skills
        </h2>
      </div>
      <div
        className={`${LeftContent} `}
        data-sal="fade"
        data-sal-duration={900}
      >
        <div className="">
          <ul className="mb-6 list-disc pl-4 md:pl-0 md:list-none fluid-text-base">
            <li>TypeScript, React, Next.js, Node, AWS, CI/CD</li>
            <li>LLM agent orchestration, MCP, prompt and context engineering, agent loops and graphs</li>
            <li>DTCG token pipelines and multi-surface export</li>
            <li>WebGL and Three.js, shaders, modern CSS architecture</li>
            <li>Agentic and node-based design tooling: Claude Design, Open Design, ComfyUI, FLORA</li>
            {/* <li>Dev Ops on LAMP, LEMP, MERN stacks</li> */}
          </ul>
        </div>
      </div>
      <div className="heading my-6 sm:my-16 block w-full ">
        <h2
          className={`${Label} fluid-text-xl`}
          data-sal="fade"
          data-sal-duration={900}
        >
          Employment History
        </h2>
      </div>
       <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2025 ~ Present
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">EU Lead Design Technologist</h3>
          <p className="job__company">
            Amazon - Brand Innovation Lab / London, United Kingdom
          </p>
          <p>
            I lead Design Technology for Europe, a team of 5 building bespoke advertising experiences across Fire TV, web, mobile and in-store. I set the technical direction the function builds against, defining the schemas, governance and standards that keep those surfaces consistent and that other teams adopt. I brought AI into how the function works, standing up the agent workflows and tooling the team now designs and prototypes with. I own the European discovery and innovation pipeline, and lead the team’s hiring, mentoring and capability development.
          </p>
        </div>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2024 ~ 2025
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">Lead Design Technologist</h3>
          <p className="job__company">
            DMI (Digital Management, LLC) / London, United Kingdom
          </p>
          <p>
            I set the strategic direction for design system governance, embedding best practices and orchestrating design-to-development handoffs. I built Figma plugins and Three.js implementations to extend what interactive experiences could do, and led R&amp;D integrating AI into customer experiences.
          </p>
        </div>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2022 ~ 2024
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">Senior Design Technologist</h3>
          <p className="job__company">
            DMI (Digital Management, LLC) / London, United Kingdom
          </p>
          <p>
            I designed and developed comprehensive design systems grounded in inclusive, human-centred principles, and brought web 3D and AI into the team’s practice. I held all work to high accessibility standards so the experiences we shipped were usable by everyone.
          </p>
        </div>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2020 ~ 2022
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">Digital Product Engineer</h3>
          <p className="job__company">alan. agency / London, United Kingdom</p>
          <p>
            I applied modern software development processes to build and scale marketer tools, design infographics, create long-form scrollytelling content, develop microsites, and architect solutions for data visualisation and reporting.
          </p>
        </div>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2016 ~ 2020
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">Full Stack Developer and Digital Designer</h3>
          <p className="job__company">
            Raconteur Media Ltd. / London, United Kingdom
          </p>
          <p>
            Led raconteur.net’s redesign, doubling views to 400k and improving client interaction. Designed and developed business-owned and client sites, including multilingual solutions. Trained design team in advanced web technologies and animated content creation, significantly enhancing our B2B digital offerings.
          </p>
        </div>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2011 ~ 2016
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">
            Co-founder, Full Stack Development and Design
          </h3>
          <p className="job__company">
            thePrintLabs Ltd. / London, United Kingdom
          </p>
          <p>
            I co-founded thePrintLabs in 2011 to serve the publishing industry with a unique approach to making digital publishing agile and future-proof. My roles spanned from Project Management to Information Architecture, Web and Mobile Design, UX/UI, and Front-end Development.
          </p>
        </div>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2008 ~ 2011
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">Web Designer</h3>
          <p className="job__company">CDB//Agency Srl / Catania, Italy</p>
          <p>
            I managed projects from concept to delivery. I trained in Server-Side Setup and Front-end Development, bridged the gap between creatives and coders, and remotely managed outsourcing partners.
          </p>
        </div>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2000 ~ 2008
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">Freelance Web Designer</h3>
          <p className="job__company">Self employed / Rome, Italy</p>
          <p>
            Choosing the web in 2000 was a deliberate bet. I taught myself Flash, multimedia CD-ROM production and 3D Studio Max long before these skills were part of any formal role. I discovered that what fascinated me wasn’t any particular technology, but the possibilities of motion, interaction and experience. I’ve approached every new technology with that same curiosity ever since.
          </p>
        </div>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          1994 ~ 2000
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <div className={Job}>
          <h3 className="fluid-text-lg">Freelance Graphic Designer</h3>
          <p className="job__company">Self employed / Catania, Italy</p>
          <p>
            I started in paper and ink: flyers for club nights, identity work for local businesses, and cross-media experiments between art and digital. Reading Munari taught me that creativity is a method of inquiry; Rams, that simplicity is a responsibility. Both are still in how I build systems.
          </p>
        </div>
      </div>
      <div className="heading my-6 sm:my-16 block w-full ">
        <h2
          className={`${Label} fluid-text-xl`}
          data-sal="fade"
          data-sal-duration={900}
        >
          Certifications
        </h2>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2025
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <ul className="edu-history">
          <li className={Job}>
            <h3 className="fluid-text-lg">AWS Certified Cloud Practitioner</h3>
            <p className="edu__place">
              Amazon Web Services - London, United Kingdom
            </p>
          </li>
        </ul>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2019
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <ul className="edu-history">
          <li className={Job}>
            <h3 className="fluid-text-lg">Certified ScrumMaster (CSM)</h3>
            <p className="edu__place">
              Scrum Alliance (via Agil8) - London, United Kingdom
            </p>
          </li>
        </ul>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2018
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <ul className="edu-history">
          <li className={Job}>
            <h3 className="fluid-text-lg">React, Redux, GraphQL</h3>
            <p className="edu__place">
              React GraphQL Academy - London, United Kingdom
            </p>
          </li>
        </ul>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          2016
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <ul className="edu-history">
          <li className={Job}>
            <h3 className="fluid-text-lg">User Experience Design</h3>
            <p className="edu__place">
              General Assembly - London, United Kingdom
            </p>
          </li>
        </ul>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          1997 ~ 1998
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <ul className="edu-history">
          <li className={Job}>
            <h3 className="fluid-text-lg">
              Digital/Multimedia and Information Resources Design
            </h3>
            <p className="edu__place">Cormorano Felix - Catania, Italy</p>
          </li>
        </ul>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          1992 ~ 1994
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <ul className="edu-history">
          <li className={Job}>
            <h3 className="fluid-text-lg">
              PPL(H), Helicopter Private Pilot Licence
            </h3>
            <p className="edu__place">COMAER - Catania, Italy</p>
          </li>
        </ul>
      </div>
      <div className="heading my-6 sm:my-16 block w-full ">
        <h2
          className={`${Label} fluid-text-xl`}
          data-sal="fade"
          data-sal-duration={900}
        >
          Education History
        </h2>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          1994 ~ 1996
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <ul className="edu-history">
          <li className={Job}>
            <h3 className="fluid-text-lg">
              Foreign Languages and Literatures (English and Spanish)
            </h3>
            <p className="edu__place">University of Catania - Catania, Italy</p>
          </li>
        </ul>
      </div>
      <div className={LeftSide}>
        <p className={Label} data-sal="fade" data-sal-duration={900}>
          1988 ~ 1992
        </p>
      </div>
      <div className={LeftContent} data-sal="fade" data-sal-duration={900}>
        <ul className="edu-history">
          <li className={Job}>
            <p className="edu__date text-gray-500"></p>
            <h3 className="fluid-text-lg">
              A Level, Aeronautical Expert Technician Diploma
            </h3>
            <p className="edu__place">
              Istituto Tecnico Aeronautico “A. Ferrarin” - Catania, Italy
            </p>
          </li>
        </ul>
      </div>
      <div className="heading my-6 sm:my-16 block w-full ">
        <h2
          className={`${Label} fluid-text-xl`}
          data-sal="fade"
          data-sal-duration={900}
        >
          Languages
        </h2>
      </div>
      {/* Bottom margin matches the gap between sections elsewhere on the page:
          LeftContent mb-7 (28px) + heading my-6/sm:my-16 (24px/64px). Was mb-k4,
          which is 33.3333% and so resolved against container WIDTH, making this
          gap grow with the viewport. */}
      <div className="mb-[3.25rem] sm:mb-[5.75rem] xs:flex w-full flex-row md:pl-k25"
      data-sal="fade" 
      data-sal-duration={900}>
        <div className={`${LeftContent} mb-0 w-full overflow-hidden lg:w-1/3`}>
          <ul className="flex flex-wrap overflow-hidden">
            <li className="lang">
              <p className="mb-0 fluid-text-sm">Italian</p>
              <div className="block w-full fluid-text-base">Native</div>
            </li>
          </ul>
        </div>

        <div className={`${LeftContent} mb-0 w-full overflow-hidden lg:w-1/3`}>
          <ul className="flex flex-wrap overflow-hidden">
            <li className="lang">
              <p className="mb-0 fluid-text-sm">English</p>
              <div className="block w-full fluid-text-base">Fluent</div>
            </li>
          </ul>
        </div>

        <div className={`${LeftContent} mb-0 w-full overflow-hidden lg:w-1/3`}>
          <ul className="flex flex-wrap overflow-hidden">
            <li className="lang">
              <p className="mb-0 fluid-text-sm">Spanish</p>
              <div className="block w-full fluid-text-base">Intermediate</div>
            </li>
          </ul>
        </div>
      </div>
      <div className={LeftSide}>
        <h2 className={Label} data-sal="fade" data-sal-duration={900}>
          Related{' '}
          <br className="hidden md:block" />Interests
        </h2>
      </div>
      <div className={`${LeftContent} mb-16`} data-sal="fade" data-sal-duration={900}>
        <p>
          Typography, Calligraphy (Chancery and Blackletter), Photography, Mathematics, Geometry, Animation, Theatre, Cinema, Novels and Literary Essays.
        </p>
      </div>
      {/* PDF download disabled 2026-08-03: PDF still carries superseded copy. */}
      {/*
      <div className={LeftSide}></div>
      <div className={`${LeftContent} mb-0`} data-sal="fade" data-sal-duration={900}>
        <p className="mb-0">
          <a
            href="https://short.kdsign.com/cv"
            alt="Download CV"
            target="_blank"
            rel="noreferrer"
            className="fluid-text-lg"
          >
            Download this CV as PDF
          </a>
        </p>
      </div>
      */}
      {/* Contact block disabled 2026-08-03: form removed, /contact/ is a stub pending redesign. */}
      {/*
      <div className={`mx-auto mt-k2 w-full sm:mb-20 lg:mb-0  `}
      data-sal="fade" 
      data-sal-duration={900}>
        <Contact />
      </div>
      */}
    </div>
  )
}

export default Cv
